import React, { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Layout, Menu, Dropdown, Avatar, Popover, Select, Button } from 'antd';
import {
  UserOutlined,
  BorderOuterOutlined,
  CodeSandboxOutlined,
  UsergroupAddOutlined
} from '@ant-design/icons';

import Cookies from 'js-cookie';
import logo from '../../assets/logo.png';
import './Layout.less';

const { Option } = Select;
const { Header, Sider, Content } = Layout;

const SiteLayout = (props) => {
  const [roleName] = useState(Cookies.get('RoleName'));
  const [userName] = useState(Cookies.get('UserName'));
  const [appID, setAppID] = useState('');
  const [projectName] = useState(Cookies.get('projectName'));
  const [active, setActive] = useState(false);
  const [appData, setAppData] = useState([]);

  const fetchData = () => {
    const appInfo = (Cookies.get('appName') !== undefined)
      ? JSON.parse(Cookies.get('appName')) : [];
    const appId = (Cookies.get('appID') !== undefined)
      ? Cookies.get('appID') : '';
    setAppData(appInfo);
    setAppID(appId);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleLogout = () => {
    const { history } = props;
    Object.keys(Cookies.get()).forEach((cookie) => {
      Cookies.remove(cookie);
    });
    history.push('/');
  };

  const onClick = (e) => {
    Cookies.set('projectName', e.item.props.dataname);
    Cookies.set('appID', e.key);
    window.location.reload(false);
  };
  const handleChange = (value) => {
    const project = appData.find((res) => res.app_id === value);
    Cookies.set('projectName', project.kl_app.app_name);
    Cookies.set('appID', project.app_id);
    setActive(true);
  };
  const menu = (
    <Menu>
      <Menu.Item onClick={handleLogout}>Logout</Menu.Item>
    </Menu>
  );
  const appMenu = (
    <Menu onClick={onClick}>
      {(appData.length > 0 && roleName !== 'super admin')
        && appData.map((res) => (
          <Menu.Item key={res.app_id} dataname={res.kl_app.app_name}>
            {res.kl_app.app_name}
          </Menu.Item>
        ))}
    </Menu>
  );


  return (
    <>
      {(roleName !== 'super admin' && !appID) && (
        <div className={`project-container ${active ? 'active' : ''}`}>
          <div>
            <label style={{ marginBottom: '8px', display: 'block' }}>
              Select a Project
            </label>
            <Select
              style={{ width: '100%' }}
              onChange={handleChange}
              placeholder="Select a project"
            >
              {appData.length > 0
                && appData.map((res) => (
                  <Option key={res.app_id} value={res.app_id}>
                    {res.kl_app.app_name}
                  </Option>
                ))}
            </Select>
          </div>
        </div>
      )}
      <Layout className={roleName !== 'campaign' ?"notify-layout":'camp-notification'} style={{ minHeight: '100vh' }}>
        <Sider className={roleName !== 'campaign' ?"sidebar":''}>
          {roleName === 'super admin' ? (
            <Menu
              theme="dark"
              className="sidebar__menu"
              defaultSelectedKeys={['user']}
              mode="inline"
            >
              <Menu.Item key="user" icon={<UserOutlined />}>
                <NavLink to="/user">User Management</NavLink>
              </Menu.Item>
            </Menu>
          ) : (
            <>
              <Menu
                theme="dark"
                className="sidebar__menu"
                defaultSelectedKeys={['channels']}
                selectedKeys={[props.location.pathname.split('/')[1]]}
                mode="inline"
              >
                {roleName !== 'campaign' && (
                <>
                  <Menu.Item key="channels" icon={<BorderOuterOutlined />}>
                    <NavLink to="/channels">Channels</NavLink>
                  </Menu.Item>
                  <Menu.Item key="developer" icon={<CodeSandboxOutlined />}>
                    <NavLink to="/developer">Developer</NavLink>
                  </Menu.Item>
                </>
                )}
                {roleName === 'campaign'
                && (
                  <>
                  <Menu.Item key="campaign" icon={<CodeSandboxOutlined />}>
                    <NavLink to="/campaign/all-campaigns">Campaigns</NavLink>
                  </Menu.Item>
                   <Menu.Item key="campaign" icon={<UsergroupAddOutlined />}>
                   <NavLink to="/campaign/all-broadCast">Add BroadCast</NavLink>
                 </Menu.Item>
                 </>
                )}
              </Menu>
            </>
          )}
        </Sider>
        <Layout className="site-layout">
        {roleName !== 'campaign' &&
          <Header
            className="site-layout-background top-header"
            style={{ padding: '0 24px' }}
          >
            <div>
              <img src={logo} className="logo" />
            </div>
            <div style={{ display: 'flex', alignItems: 'center' }}>

              {(roleName !== 'super admin' && appData.length > 1 && roleName !== 'campaign') && (
              <Dropdown Button overlay={appMenu} placement="bottomRight" arrow>
                <h4 className="ant-dropdown-link">
                  {' '}
                  {projectName || 'Projects'}
                  {' '}
                </h4>
              </Dropdown>
              )}
              {(roleName !== 'super admin' && appData.length === 0 && roleName !== 'campaign') && (
              <Popover content={projectName} title="Project">
                <h4>
                  {' '}
                  {projectName || 'Projects'}
                  {' '}
                </h4>
              </Popover>
              )}
              <Dropdown overlay={menu} placement="bottomRight" arrow>
                <button className="btn-dual" style={{ marginLeft: '20px' }}>
                  <Avatar size={28}>{userName && userName.charAt(0).toUpperCase()}</Avatar>
                &nbsp;
                  <span style={{ verticalAlign: '-2px' }}>{userName}</span>
                </button>
              </Dropdown>
            </div>
          </Header>
        }
          <Content style={{ margin: '0 16px' }} className="page-content">
            {props.children}
          </Content>
        </Layout>
      </Layout>
    </>
  );
};

export default SiteLayout;
